import useTypedSelector from '../../../common/hook/useTypedSelector';
import GridModule from '../../common/component/GridModule';
import HomeFooter from '../../common/component/HomeFooter';
import useMainListEventHandler from '../hook/useMainListEventHandler';

export default function HotList() {
  const hotList = useTypedSelector(state => state.main.hotList);
  const hasAdminSection = hotList.some(mainItem => mainItem.isAdminSection);

  const {
    handleClickBigContent,
    handleClickContent,
    sendViewImpBigContent,
    sendViewImpContent,
    handleClickPromotionVideo,
    handleClickPromotionVideoMute,
    handleClickPromotionVideoPlay,
  } = useMainListEventHandler();

  return (
    <>
      {hotList.map((item, index) => {
        const hideTitle = !hasAdminSection && index === 0;
        return (
          <GridModule
            key={index}
            item={item}
            hideTitle={hideTitle}
            className={cn({
              'mt-42': item.title && !hideTitle,
            })}
            onClickBigContent={({content, index}) =>
              handleClickBigContent({item, content, index})
            }
            onClickContent={({content, index}) =>
              handleClickContent({item, content, index})
            }
            onSendViewImpBigContent={({content, index}) =>
              sendViewImpBigContent({item, content, index})
            }
            onSendViewImpContent={({content, index}) =>
              sendViewImpContent({item, content, index})
            }
            onClickPromotionVideo={({content, index}) =>
              handleClickPromotionVideo({item, content, index})
            }
            onClickPromotionVideoMute={(isMute, {content, index}) =>
              handleClickPromotionVideoMute(isMute, {item, content, index})
            }
            onClickPromotionVideoPlay={({content, index}) =>
              handleClickPromotionVideoPlay({item, content, index})
            }
          />
        );
      })}
      {hotList.length > 0 && <HomeFooter />}
    </>
  );
}
